import {App} from "../App";
import React from "react";
import DownloadApp from "./Root";
import cs from "./index.module.less";
import {getString} from "../index";
import {DownloadAppPopover} from "./DownloadAppPopover";

export const DownloadPage = () => {
    const sUserAgent = navigator.userAgent
    let isMobile = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent.toLowerCase());
    let isAndroid = sUserAgent.indexOf("Android") > -1 || sUserAgent.indexOf("Adr") > -1;

    if (!isMobile) {
        return (
            <App>
                <DownloadApp showQRCode titleColor={"#052337"}/>
            </App>
        )
    }

    return (
        <App>
            <div className={cs.download_wrap_mobile}>
                <div className={cs.download_title}>
                    {`${getString("slogan_2fa")}`}
                </div>
                <DownloadAppPopover isAndroid={isAndroid}/>

                <div className={cs.download_footer_img}/>
            </div>
        </App>
    )
}
